import trunkrs from 'common/utils/Sdk'

export const invalidateAuth = () =>
  trunkrs.Auth().invalidate()
